// const SERVER = "http://localhost:8080"
const SERVER = "https://dbs21.seleksibinaantarbudaya.or.id"

export default SERVER